import { render, staticRenderFns } from "./LecturesHalls.vue?vue&type=template&id=c9a1e94a&scoped=true"
import script from "./LecturesHalls.vue?vue&type=script&lang=js"
export * from "./LecturesHalls.vue?vue&type=script&lang=js"
import style0 from "./LecturesHalls.vue?vue&type=style&index=0&id=c9a1e94a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a1e94a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9a1e94a')) {
      api.createRecord('c9a1e94a', component.options)
    } else {
      api.reload('c9a1e94a', component.options)
    }
    module.hot.accept("./LecturesHalls.vue?vue&type=template&id=c9a1e94a&scoped=true", function () {
      api.rerender('c9a1e94a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LecturesHalls.vue"
export default component.exports